define('formkit/view/form.object/content/dropdown.content.view',['require','exports','module','underscore','uikit/uikit','../../../templates','./base.selectable.content.view','../../../behavior/single.answer.value.behavior'],function(require, exports, module){
  var _                         = require('underscore');
  var UIKit                     = require('uikit/uikit');
  var Templates                 = require('../../../templates');
  var BaseSelectableContentView = require('./base.selectable.content.view');
  var SingleAnswerValueBehavior = require('../../../behavior/single.answer.value.behavior');


  var DesignAnswerView = BaseSelectableContentView.DesignAnswerView.extend({
    template: Templates.App['dropdown.object.design']
  });

  var PreviewAnswerView = BaseSelectableContentView.PreviewAnswerView.extend({
    template: Templates.App['dropdown.object.preview'],
    internalViewOptions: BaseSelectableContentView.PreviewAnswerView.extendInternalViewOptions({
      groupView: function(){
        var self = this;
        return {
          type: UIKit.Dropdown.extend({
            getChildView: function(){
              return this.getOption('childView');
            },
          }),
          readonly: this.getOption('readonly'),
          fluid: true,
          value: this.form.util.findChildWithTruthyAnswer(this.model, this.getAnswerValueIndex()),
          placeholder: 'Select a value...',
          childViewOptions: function(model){
            return {
              form: this.form,
              model: model,
              answerValueModel: self.getAndLinkAnswerValueModel(model, self.form),
              answerModel: this.form.getAnswerModel(model),
              dropdownView: this
            }
          },
          childView: UIKit.Dropdown.ItemView.extend({
            attributes: function() {
              return {
                'data-id' : this.model ? this.model.id : null
              }
            },

            onFirstRender: function() {
              var dropdownView = this.getOption('dropdownView');
              this.listenTo(dropdownView, 'change:value', function(dropdownItemView, value, previous, options) {

                this.answerValueModel.set('value', dropdownView.value === this.model, {
                  isFromServer: _.result(options, 'isFromServer')
                });

                if (!_.result(options, 'isFromServer')) {
                  this.form.triggerBeginEditAnswerEvent(dropdownView, this.model, {
                    answerValueModel: this.answerValueModel
                  });
                  this.form.triggerEndEditAnswerEvent(dropdownView, this.model, {
                    answerValueModel: this.answerValueModel
                  });
                }
              });

              this.listenTo(this.answerValueModel, 'change:value', function(model, value, options){
                this.determineDropdownViewModel(options);
              });
            },

            determineDropdownViewModel: function(options){
              var dropdownView = this.getOption('dropdownView');

              if (this.answerValueModel.get('value') === true) {
                dropdownView._setOption('value', this.model, {
                  isFromServer: _.result(options, 'isFromServer')
                });
              }

              if ((this.answerValueModel.get('value') === false) && (dropdownView.value === this.model)) {
                dropdownView._setOption('value', null, {
                  isFromServer: _.result(options, 'isFromServer')
                });
              }
            },
            behaviors: {
              SingleAnswerValueBehavior: {
                resetValue: false,
                isMultiAnswerValue: self.getOption('isMultiAnswerValue'),
                answerValueIndex: self.getAnswerValueIndex(),
                behaviorClass: SingleAnswerValueBehavior
              }
            }
          })
        }
      }
    })
  });

  var DropdownContentView = BaseSelectableContentView.extend({
    internalViewOptions: BaseSelectableContentView.extendInternalViewOptions({
      designAnswerView: function(){
        return {
          type: DesignAnswerView,
          form: this.getOption('form'),
          model: this.model
        }
      },
      previewAnswerView: function(){
        return {
          type: PreviewAnswerView,
          form: this.getOption('form'),
          model: this.model
        }
      }
    })
  });

  DropdownContentView.PreviewAnswerView = PreviewAnswerView;
  DropdownContentView.DesignAnswerView = DesignAnswerView;

  module.exports = DropdownContentView;
});

